export const getEligibleClassCodesForCOA = (config) => {
  if (!config?.classCodeConfig) return new Set()

  return new Set(config.classCodeConfig.filter((item) => item.coaOnlineInd === 'Y').map((item) => item.code))
}

export const getIneligibleClassCodesForCOA = (config) => {
  if (!config?.classCodeConfig) return new Set()

  return new Set(config.classCodeConfig.filter((item) => item.coaOnlineInd === 'N').map((item) => item.code))
}

export const getEligibleDPSCForCOA = (config) => {
  if (!config?.driverPrivilegeStatusConfig) return new Set()

  return new Set(
    config.driverPrivilegeStatusConfig.filter((item) => item.coaOnlineInd === 'Y').map((item) => item.code),
  )
}

export const getIneligibleDPSCForPhotoID = (config) => {
  if (!config?.driverPrivilegeStatusConfig) return new Set()

  return new Set(
    config.driverPrivilegeStatusConfig
      .filter((item) => item.coaOnlineInd === 'N' && item.photoIdInd === 'N')
      .map((item) => item.code),
  )
}

export const getEligibleRecordTypesForCOA = (config) => {
  if (!config?.recordTypeConfig) return new Set()

  return new Set(config.recordTypeConfig.filter((item) => item.coaOnlineInd === 'Y').map((item) => item.code))
}

export const getInvalidSchoolBusPrivilegeCodes = () => {
  return new Set(['DQ', 'CA', 'SU', 'RE', 'RC'])
}

export const getInvalidSchoolBusProductCodes = () => {
  return ['CT', 'CM']
}

export const getEligibleClassCodesForRenewal = (config) => {
  if (!config?.classCodeConfig) return new Set()

  return new Set(config.classCodeConfig.filter((item) => item.renewOnlineInd === 'Y').map((item) => item.code))
}

export const getIneligibleClassCodesForRenewal = (config) => {
  if (!config?.classCodeConfig) return new Set()

  return new Set(config.classCodeConfig.filter((item) => item.renewOnlineInd === 'N').map((item) => item.code))
}

export const getEligibleDPSCForRenewal = (config) => {
  if (!config?.driverPrivilegeStatusConfig) return new Set()

  return new Set(
    config.driverPrivilegeStatusConfig.filter((item) => item.renewOnlineInd === 'Y').map((item) => item.code),
  )
}

export const getIneligibleDPSCForRenewal = (config) => {
  if (!config?.driverPrivilegeStatusConfig) return new Set()

  return new Set(
    config.driverPrivilegeStatusConfig.filter((item) => item.renewOnlineInd === 'N').map((item) => item.code),
  )
}

export const getEligibleClassCodesForDuplicate = (config) => {
  if (!config?.classCodeConfig) return new Set()
  return new Set(config.classCodeConfig.filter((item) => item.duplicateOnlineInd === 'Y').map((item) => item.code))
}

export const getIneligibleClassCodesForDuplicate = (config) => {
  if (!config?.classCodeConfig) return new Set()
  return new Set(config.classCodeConfig.filter((item) => item.duplicateOnlineInd === 'N').map((item) => item.code))
}

export const getEligibleDPSCForDuplicate = (config) => {
  if (!config?.data?.driverPrivilegeStatusConfig) return new Set()
  return new Set(
    config.data.driverPrivilegeStatusConfig.filter((item) => item.duplicateOnlineInd === 'Y').map((item) => item.code),
  )
}
